import React, { useState } from 'react';
import infoIcon from '../assets/info.svg'
import closeIcon from "../assets/closeIcon.svg"
import { Modal, Dialog, Box } from '@material-ui/core';
import useWorkOrders from "../hooks/useWorkOrders";

const VoidedWO = (props) => {
    
    const {
        setRemovedWO, 
        setIsWOSelected
    } = useWorkOrders();

    const handleClose = () => {
        setIsWOSelected(false);
        setRemovedWO([])
    }

    return (
        <>
        <Dialog className="modal" open={true} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
             <Box className='safetyPrintModal'>
                <div className='modalIcons'>
                    <img src={infoIcon} alt='infoIcon'/>
                    <button><img src={closeIcon} alt='CloseButton' onClick={handleClose}/></button>
                </div>
                <div className='modalText'>
                    <p>This work order has recently been voided and can no longer be edited. <br></br> You will be redirected to work orders list</p>
                    <button id='back-button' onClick={handleClose}> OK </button>
                </div>
            </Box>
        </Dialog>
               
        </>
    )
}
export default VoidedWO;